export function syncAsync(fn, ...fns) {
    let value = fn();
    for (const fnEntry of fns) {
        if (value instanceof Promise) {
            value = value.then(fnEntry);
        }
        else {
            value = fnEntry(value);
        }
    }
    return value;
}
